import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import * as Sentry from "@sentry/remix";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
  dsn: "https://37dbef4a910c8521e423f5759d8bfb31@o4507088806543360.ingest.us.sentry.io/4511623421296640",
  enabled: import.meta.env.VITE_SENTRY_ENV !== "development",
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 0.01,
  profilesSampleRate: 0.01,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
